import { ajaxListNovedades } from '../functions/ajax-settings.js';


document.addEventListener("DOMContentLoaded", () => {

    ajaxListNovedades();

});
